import { useState } from "react";
import { Sheet } from "./Sheet";
import { useT } from "../../lib/LocaleContext";

export function NoteSheet({
  open,
  title,
  placeholder,
  onSubmit,
  onClose,
}: {
  open: boolean;
  title: string;
  placeholder: string;
  onSubmit: (text: string) => void;
  onClose: () => void;
}) {
  const [text, setText] = useState("");
  const t = useT();

  function handleSubmit() {
    if (!text.trim()) return;
    onSubmit(text.trim());
    setText("");
  }

  return (
    <Sheet open={open} onClose={onClose} title={title}>
      <textarea
        className="field__input note-textarea"
        placeholder={placeholder}
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={4}
        autoFocus
      />
      <button
        type="button"
        className="btn btn--primary btn--block"
        style={{ marginTop: "1rem" }}
        disabled={!text.trim()}
        onClick={handleSubmit}
      >
        {t.noteSheet.save}
      </button>
    </Sheet>
  );
}
